import React from 'react';
import PropTypes from 'prop-types';

import Browser from '@wetransfer/concorde-browser';

import VideoIllustration from '@component/illustration/video-illustration';
import I18n from '@module/i18n';

const EmailVerificationUpsell = ({
  transfer,
  onRequestClose,
  onFreeAccountUpsellClick,
}) => {
  return (
    <React.Fragment>
      <div className="email-verification-upsell">
        <VideoIllustration
          type="transfer-complete-upload"
          src="transfer_window/transfer_completed-3"
          className="email-verification-upsell__illustration"
        />
        <h2 className="email-verification-upsell__header">
          {I18n.t('transfer.complete_email.title')}
        </h2>
        <p
          dangerouslySetInnerHTML={{
            __html: I18n.t('transfer.complete_email.text_no_details', {
              expires: I18n.relativeTime(transfer.expiryInSeconds),
            }),
          }}
          className="email-verification-upsell__body"
        />
        {!Browser.isMobile && (
          <button
            onClick={onRequestClose}
            className="email-verification-upsell__button"
          >
            {I18n.t('transfer.buttons.done')}
          </button>
        )}
      </div>
      <div className="email-verification-upsell__footer">
        <p className="email-verification-upsell__footer-body">
          {I18n.t('transfer.email-verification-success.upsell')}
        </p>
        <button
          className="transfer__button email-verification-upsell__footer-button"
          onClick={onFreeAccountUpsellClick}
        >
          {I18n.t('transfer.email-verification-success.free_signup')}
        </button>
      </div>
    </React.Fragment>
  );
};

EmailVerificationUpsell.propTypes = {
  transfer: PropTypes.object.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onFreeAccountUpsellClick: PropTypes.func.isRequired,
};

export default EmailVerificationUpsell;
